import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

import { School, Program, StudyOption } from 'app/types';

// Define a type for the slice state
export interface ExploreState {
  school?: School;
  program?: Program;
  studyOption?: StudyOption;
  comesFromExplore: boolean;
}

// Define the initial state using that type
const initialState: ExploreState = {
  school: undefined,
  program: undefined,
  studyOption: undefined,
  comesFromExplore: false,
};

export const exploreSlice = createSlice({
  name: 'explore',
  initialState,
  reducers: {
    setSchool: (state: ExploreState, action: PayloadAction<School | undefined>) => {
      state.school = action.payload;
    },
    setProgram: (state: ExploreState, action: PayloadAction<Program | undefined>) => {
      state.program = action.payload;
    },
    setStudyOption: (state: ExploreState, action: PayloadAction<StudyOption | undefined>) => {
      state.studyOption = action.payload;
    },
    setFromExplore: (state: ExploreState, action: PayloadAction<boolean>) => {
      state.comesFromExplore = action.payload;
    },
  },
});

export const { setSchool, setProgram, setStudyOption, setFromExplore } = exploreSlice.actions;

export default exploreSlice.reducer;
